import React from "react";
import { hasCategoryAccess, hasPermission } from "./permission.service";

/**
 * Hook form — returns boolean. Use when you need to disable (not hide) UI,
 * or compose with other conditions.
 *
 *   const canVerify = usePermission('QA Actions', 'Verify Answer');
 */
export const usePermission = (category: string, action?: string): boolean => {
  if (!action) return hasCategoryAccess(category);
  return hasPermission(category, action);
};

interface Props {
  category: string;
  action?: string;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Component form — hides children when the user lacks the permission.
 *
 *   <PermissionGate category="QA Actions" action="Resolve Answer Conflict">
 *     <Button>Resolve</Button>
 *   </PermissionGate>
 *
 * If `action` is omitted, checks category-level access (any sub-permission).
 */
const PermissionGate: React.FC<Props> = ({ category, action, fallback = null, children }) => {
  const allowed = usePermission(category, action);
  return <>{allowed ? children : fallback}</>;
};

export default PermissionGate;
